"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWebGLContext = void 0;

function getWebGLContext() {
  if (typeof document === 'undefined') {
    return null;
  }

  const canvas = document.createElement('canvas');
  canvas.width = 256;
  canvas.height = 128;
  const webgl = canvas.getContext('webgl', {
    preserveDrawingBuffer: true
  });
  return webgl;
}

exports.getWebGLContext = getWebGLContext;